import { Chip } from "@mui/material";
import CompatibilityViolation from "../types/CompatibilityViolation"
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

interface CompatibilityChipProps {
    violation: CompatibilityViolation
    onClick: (violation: CompatibilityViolation) => void
}

const CompatibilityChip = ({ violation, onClick }: CompatibilityChipProps) => {
    const isIncompatible = violation?.incompatibilities?.length;

    return <Chip
        label={violation.type}
        color={isIncompatible ? 'error' : 'success'}
        variant="outlined"
        className="m-1"
        onDelete={isIncompatible ? () => onClick(violation) : undefined}
        deleteIcon={isIncompatible ? <HelpOutlineIcon /> : undefined} />

}

export default CompatibilityChip;